'use client';

import type { ImageGalleryFragment } from '@packages/gql/generated/shopping/graphql';
import { useResponsiveAkamaiTemplate } from '@packages/modules/src/hooks/useResponsiveAkamaiTemplate/useResponsiveAkamaiTemplate';
import { Image } from '@packages/shared/src/ui/Image/Image';
import { useIsDialogOpen } from '../ImageGalleryProvider/ImageGalleryProvider.client';

type ImageGalleryImageProps = {
  url: ImageGalleryFragment['media'][number]['url'];
  name: ImageGalleryFragment['name'];
  isFirstImage?: boolean;
};

/**
 * ImageGalleryImageWrapper is a wrapper component that exists as a client component
 * to wrap the image and handle the click event for opening the image gallery dialog.
 * You can pass a server component as a child to this wrapper.
 */
export const ImageGalleryImage = ({ url, name, isFirstImage }: ImageGalleryImageProps) => {
  const [, setIsDialogOpen] = useIsDialogOpen();
  const { templateName: galleryTemplateName } = useResponsiveAkamaiTemplate('gallery');

  return (
    <button className="cursor-pointer" onClick={() => setIsDialogOpen(true)} type="button">
      <Image
        src={`${url}?${galleryTemplateName}`}
        alt={name}
        fill
        className="object-contain"
        priority={isFirstImage}
        fetchPriority={isFirstImage ? 'high' : 'low'}
        loading={isFirstImage ? 'eager' : 'lazy'}
        noLoader={isFirstImage}
      />
    </button>
  );
};
